<template>
    <circle
        v-bind="{
            class : 'tool_svgElem',
            style : 'transition: r 0.5 ease-in-out;',
            id   : tool.id + '-body',
            cx   : tool.coords.pts[0].x, 
            cy   : tool.coords.pts[0].y,
            r    : radiusSize/GET_waZoomScale * (activeContext ? selFactor : 1),
            fill : toolColor
        }"
    > 
    </circle>
</template>

// =========================================================================================
// =========================================================================================

<script>
import { mapState } from 'vuex';
import { tools  } from '../../mixins/tools';
import { mapGetters } from 'vuex/dist/vuex.common.js';

// =========================================================================================

export default {
    name : 'ptoCMP',
    props: {
        toolColor   : { type : String  },
    }, 

    // -----------------------------------------------------------------

    mixins: [tools],

    // -----------------------------------------------------------------

    data () {
        return {
            radiusSize : 4,
            selFactor  : 1.5
        }
    },

    // -----------------------------------------------------------------

    computed: {
        ...mapState([
        ]),

        ...mapGetters([
            'GET_waZoomScale',
        ]),

        // -----------------------------------------------------------------

        activeContext() {
            return this.localState.isToolLabelActive || this.isToolDenteActive;
        } 
    },

    // -----------------------------------------------------------------

    methods: {        
    },
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>
.rTransition {
    transition: r 0.5 ease-in-out;
}

</style>